export default __webpack_public_path__ + "static/media/novotel_challenge-1.1c03bb2b.jpg";